import { globalStyles } from "@client/shared/constants";
const style = {
  actions: {
    width: 750,
  },
  activeStep: {
    "& img": {
      transform: "scale(1.2, 1.2)",
    },
    "& span": {
      ...globalStyles.text.color.primary,
      fontSize: "1.1 rem",
    },
  },
  greyAction: {
    color: "grey.500",
    borderColor: "grey.500",
  },
  reviewHeader: {
    color: "rgb(47,47,47)",
    fontSize: 20,
    fontWeight: "bold",
    letterSpacing: 0.07,
    paddingLeft: "12px",
    marginTop: 3,
    marginLeft: 4,
  },
  step: {
    width: 100,
    color: "gry",
  },
  successStep: {
    ...globalStyles.text.color.success,
  },
  stepper: {
    height: 57,
    width: 750,
  },
  pageHeadingWrapper: {
    margin: "24px 0 40px 48px",
    position: "relative",
  },
  pageHeading: {
    color: "black",
    fontSize: 24,
    // fontFamily: "medium",
    fontWeight: 500,
    letterSpacing: 0.08,
  },
  pageHeadingCaption: {
    color: "gray",
    fontFamily: "regular",
    fontSize: 12,
    letterSpacing: 0.17,
  },
  pageHeadingMarker: {
    background: "#7f5bdb",
    height: 70,
    width: 4,
    position: "absolute",
    left: -24,
    top: 0,
  },
  progressBtn: {
    position: "absolute",
    top: "60%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
};

export default style;
